module.exports = __webpack_public_path__ + "static/media/Montserrat-ExtraLightItalic.d61b7283.ttf";